module.exports = __webpack_public_path__ + "img/wordpaste.c78d5085.png";